import { Crown } from 'lucide-react'
import { cn } from '../lib/utils'

// The dub Champ crown: marks a group's top scorer for a finished tournament,
// and fronts the default "Bragging Rights" prize.
export default function DubChampBadge({ className, label = 'dub Champ' }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full bg-[var(--lemon-3)] px-2 py-0.5 text-xs font-semibold text-[var(--lemon-12)]',
        className,
      )}
    >
      <Crown className="h-3.5 w-3.5 text-[var(--color-crown)]" aria-hidden="true" />
      {label}
    </span>
  )
}
